<template>
  <div class="right-menu" :class="{ 'right-menu__active': isVisible }" @mousedown.stop>
    <div class="right-menu__content">
      <div class="right-menu-header">
        <div class="right-menu-header__title">
          <template v-if="isAuthorized">
            <span v-if="editObject.id === 'new'">Добавить запись</span>
            <span v-else>Обновить запись</span>
          </template>
          <span v-else>Просмотр записи</span>
        </div>
        <button type="button" class="right-menu-header__close-menu" @click="onCloseMenu" />
      </div>

      <div v-if="uploadData" class="processing-overlay">
        <circle-loader size="xlarge" :indeterminate="true" />
      </div>

      <div :class="{ 'upload-data': uploadData }" class="right-menu-content">
        <div v-if="isAuthorized" class="form-wrapper">
          <div class="row">
            <div class="col-12">
              <form-select
                :input-model="editObject.year"
                :input-options="periodOptions"
                :error="validationErrors.year"
                fieldname="editObject.year"
                label="Год"
                placeholder="Год"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <search-form
                :input-model="editObject.fkko"
                placeholder="Введите наименование или код ФККО"
                label="ФККО"
                suggest-field-type="name"
                :get-data="searchTerm => getFKKOChilds(searchTerm)"
                :bottom-info="searchBottomInfo"
                :error="validationErrors.fkko"
                error-info="Выберите категорию отходов"
                @reset="onResetSearchForm"
                @select-suggestion="onSelectSearchFormSuggestion"
                @blur="onBlurSearchForm"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                :input-model="editObject.year_begin"
                :error="validationErrors.year_begin"
                fieldname="editObject.year_begin"
                label="На начало года"
                placeholder="На начало года"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <form-data
                :error="validationErrors.created"
                :input-model="editObject.created"
                fieldname="editObject.created"
                label="Образовано"
                placeholder="Образовано"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                :error="validationErrors.received"
                :input-model="editObject.received"
                fieldname="editObject.received"
                label="Получено"
                placeholder="Получено"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <form-data
                :error="validationErrors.processed"
                :input-model="editObject.processed"
                fieldname="editObject.processed"
                label="Обработано"
                placeholder="Обработано"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                :error="validationErrors.recycled"
                :input-model="editObject.recycled"
                fieldname="editObject.recycled"
                label="Утилизировано"
                placeholder="Утилизировано"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <form-data
                :error="validationErrors.neutralized"
                :input-model="editObject.neutralized"
                fieldname="editObject.neutralized"
                label="Обезврежено"
                placeholder="Обезврежено"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                :error="validationErrors.disposed"
                :input-model="editObject.disposed"
                fieldname="editObject.disposed"
                label="Захоронено"
                placeholder="Захоронено"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <form-data
                :error="validationErrors.stored"
                :input-model="editObject.stored"
                fieldname="editObject.stored"
                label="Хранение"
                placeholder="Хранение"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                :error="validationErrors.sended"
                :input-model="editObject.sended"
                fieldname="editObject.sended"
                label="Передано"
                placeholder="Передано"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <form-data
                :error="validationErrors.year_end"
                :input-model="editObject.year_end"
                fieldname="editObject.year_end"
                label="На конец года"
                placeholder="На конец года"
                :keymonitor="keymonitor"
                @update="updateData"
              />
            </div>
          </div>
          <span v-if="numericErrorNote" class="group-error">
            Необходимо, что-бы хотя-бы одно поле со значением было заполнено
          </span>
        </div>
        <div v-else class="form-wrapper">
          <div class="row">
            <div class="col-12">
              <form-select
                fieldname="editObject.year"
                label="Год"
                placeholder="Год"
                :input-model="editObject.year"
                :input-options="periodOptions"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <search-form
                :input-model="editObject.fkko"
                placeholder="Введите наименование или код ФККО"
                label="ФККО"
                suggest-field-type="name"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                fieldname="editObject.year_begin"
                label="На начало года"
                placeholder="На начало года"
                :input-model="editObject.year_begin"
                :disable="true"
              />
            </div>
            <div class="col-6">
              <form-data
                fieldname="editObject.created"
                label="Образовано"
                placeholder="Образовано"
                :input-model="editObject.created"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                fieldname="editObject.received"
                label="Получено"
                placeholder="Получено"
                :input-model="editObject.received"
                :disable="true"
              />
            </div>
            <div class="col-6">
              <form-data
                fieldname="editObject.processed"
                label="Обработано"
                placeholder="Обработано"
                :input-model="editObject.processed"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                fieldname="editObject.recycled"
                label="Утилизировано"
                placeholder="Утилизировано"
                :input-model="editObject.recycled"
                :disable="true"
              />
            </div>
            <div class="col-6">
              <form-data
                fieldname="editObject.neutralized"
                label="Обезврежено"
                placeholder="Обезврежено"
                :input-model="editObject.neutralized"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                fieldname="editObject.disposed"
                label="Захоронено"
                placeholder="Захоронено"
                :input-model="editObject.disposed"
                :disable="true"
              />
            </div>
            <div class="col-6">
              <form-data
                fieldname="editObject.stored"
                label="Хранение"
                placeholder="Хранение"
                :input-model="editObject.stored"
                :disable="true"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <form-data
                fieldname="editObject.sended"
                label="Передано"
                placeholder="Передано"
                :input-model="editObject.sended"
                :disable="true"
              />
            </div>
            <div class="col-6">
              <form-data
                fieldname="editObject.year_end"
                label="На конец года"
                placeholder="На конец года"
                :input-model="editObject.year_end"
                :disable="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="right-menu-footer">
        <template v-if="isAuthorized">
          <regular-button type="button" :rounded="true" :disabled="isAddButtonDisabled" @click.stop="onSaveObject">
            <span v-if="editObject.id === 'new'">добавить</span>
            <span v-else>обновить</span>
          </regular-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import FormSelect from "../../../../components/forms/FormSelect";
import FormData from "../../../../components/forms/FormData";
import CircleLoader from "../../../../components/CircleLoader";
import RegularButton from "../../../../components/RegularButton";
import { isObject } from "../../../../common";

import SearchForm from "./SearchForm.vue";

export default {
  name: "RightMenu",
  components: {
    FormSelect,
    FormData,
    SearchForm,
    CircleLoader,
    RegularButton
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  inject: ["reloadBQCList"],
  data() {
    return {
      // openRouteId: null,
      // routeListRequested: false,
      searchBottomInfo: "",
      uploadData: false,
      isAddButtonDisabled: false,
      validationErrors: {
        year: false,
        fkko: false,
        year_begin: false,
        created: false,
        recycled: false,
        utilized: false,
        neutralized: false,
        allolocated: false,
        sended: false,
        year_end: false
      },
      requiredFields: ["year", "fkko"],
      numericFields: ["year_begin", "year_end", "created", "received", "recycled", "neutralized", "allocated", "sended"],
      numericErrorNote: false
    };
  },
  computed: {
    ...mapState(["isAuthorized"]),
    ...mapState("analiticsBQC", ["editObject", "parentId"]),
    ...mapState({
      periodOptions: state => state.analiticsBQC.periodOptions()
    })
  },
  methods: {
    ...mapActions(["getSource"]),
    ...mapActions("analiticsBQC", ["cancelEditing", "addNewObject", "updateObject"]),
    ...mapMutations("analiticsBQC", ["updateEditObject"]),
    onCloseMenu(event) {
      this.$emit("close-menu", event);
    },
    onDisableEditMode() {
      this.uploadData = true;

      this.cancelEditing().then(() => {
        this.uploadData = false;
      });
    },
    keymonitor() {
      this.numericErrorNote = false;
      this.validationErrors = {
        year: false,
        fkko: false,
        year_begin: false,
        created: false,
        received: false,
        recycled: false,
        neutralized: false,
        allocated: false,
        sended: false,
        year_end: false
      };
    },
    updateData(data) {
      const target = data.fieldname.split(".");
      const dataType = typeof data.value === "undefined";

      if (target.length === 1) {
        this[target[0]] = dataType ? null : data.value;
      }
      if (target.length === 2) {
        this[target[0]][target[1]] = dataType ? null : data.value;
        // this.updateField(this.editObject.id, target[1], dataType ? null : data.value);
      }
    },
    getFKKOChilds(searchTerm) {
      return this.getSource({
        url: "/api/dicts/fkko",
        params: {
          search: searchTerm,
          page_size: 5,
          only_leaf: true
        }
      }).then(res => {
        if (res.status === 200) {
          return res.data.results;
        }
        return [];
      });
    },
    onResetSearchForm(element) {
      this.updateData({ value: null, fieldname: "editObject.fkko" });
      element.inputValue = "";
      this.searchBottomInfo = "";
    },
    onBlurSearchForm(element) {
      // очищаем поле если пользователь не выбрал fkko из списка и/или ввёл произвольный текст
      if (!isObject(this.editObject.fkko)) {
        element.inputValue = "";
        element.showSuggestions = "";
      }
    },
    onSelectSearchFormSuggestion({ element, suggest }) {
      element.showSuggestions = false;
      element.inputValue = suggest[element.suggestFieldType];
      this.searchBottomInfo = suggest["code"];
      this.updateData({ value: suggest, fieldname: "editObject.fkko" });
      this.keymonitor();

      this.fillFormIfObjectExist();
    },
    onCheckRequires() {
      const requires = this.requiredFields.reduce((arr, item) => {
        if (this.editObject[item] == null) {
          arr.push(item);
          this.validationErrors[item] = true;
        }
        return arr;
      }, []);

      const numericFieldsIsNotNullable = this.numericFields.some(field => {
        return this.editObject[field] !== null && this.editObject[field] !== "" && this.editObject[field].length > 0;
      });

      // Хотя-бы ондно из полей numericFields заполнено
      if (!numericFieldsIsNotNullable) {
        this.numericErrorNote = true;
        this.numericFields.map(field => {
          requires.push(field);
          this.validationErrors[field] = true;
        });
      }

      // поля соответствуют значению регулярного выражения ~ "10.000", "10,000"
      this.numericFields
        .filter(field => {
          if (typeof this.editObject[field] !== "undefined" && this.editObject[field] !== null && this.editObject[field] !== "") {
            return this.editObject[field].length > 0;
          }
        })
        .map(field => {
          const regexp = /^[0-9]*?(,|\.)?[0-9]{1,3}$/;
          const value = this.editObject[field];

          if (regexp.test(value) === false) {
            requires.push(field);
            this.validationErrors[field] = true;
          }
        });

      return requires.length === 0 || false;
    },
    onSaveObject() {
      const editObject = {
        ...this.editObject,
        fkko_id: this.editObject.fkko ? this.editObject.fkko.id : null
      };

      this.numericFields.map(field => {
        if (editObject[field] === null || editObject[field] === "") {
          editObject[field] = 0;
        }
      });

      if (!this.onCheckRequires()) {
        return;
      }

      this.uploadData = true;
      this.isAddButtonDisabled = true;

      if (editObject.id === "new") {
        delete editObject.id;

        this.addNewObject(editObject).then(() => {
          this.uploadData = true;
          this.isAddButtonDisabled = true;
          this.$emit("close-menu");
          this.reloadBQCList();
        });
      } else {
        this.updateObject({ data: editObject, year: editObject.year, fkko_id: editObject.fkko_id }).then(() => {
          this.uploadData = false;
          this.isAddButtonDisabled = false;
          this.$emit("close-menu");
          this.reloadBQCList();
        });
      }
    },
    fillFormIfObjectExist() {
      const { year, fkko } = this.editObject;

      this.getSource({ url: `/api/balance/simulated/${year}/${fkko.id}/` }).then(response => {
        if (response.status === 200) {
          this.updateEditObject({
            ...response.data,
            year,
            fkko
          });
        }
      });
    }
  }
};
</script>
